import { BenchmarkingRequestParams } from '@/hooks'
import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'

export function mapBenchmarkingParamsToFilters(
    params: BenchmarkingRequestParams
): ReportFiltersValues {
    function splitIds(val?: string): number[] {
        return val ? val.split(',').filter(Boolean).map(Number) : []
    }

    return {
        node: splitIds(params['nodeIds[]']),
        commodity: splitIds(params.commodityTypeId),
        provider: splitIds(params['providerIds[]']),
        contract: splitIds(params['contractIds[]']),
        account: splitIds(params['panIds[]']),
        tag: splitIds(params['tagIds[]']),
        facility: splitIds(params['facilityIds[]']),
        meter: splitIds(params['meterIds[]']),
        usn: splitIds(params['usnAccountIds[]']),
        calculation: 'productionMonth',
        timeline: {
            type: 'isBetween',
            value: {
                startDate: params.startDate,
                endDate: params.endDate,
            },
        },
        unitOfMeasureId: params.unitOfMeasureId
            ? [Number(params.unitOfMeasureId)]
            : [],
    }
}
